import axios from 'axios'
import router from '@/router' // 添加这行导入
// console.log( process.env.VUE_APP_BASE_API)
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '', // api的base_url
  timeout: 500000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = localStorage.getItem('token')
    
    // 如果token存在，则添加到请求头中
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.error('请求错误：', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
      // 401: 未登录或token过期
      if (res.code == 401) {
        // 清除token
        if(localStorage.getItem("token")){
          localStorage.removeItem('token')
          // 跳转到登录页
          router.push('/home')
        //   ElMessage({
        //     message:  '认证失败，请重新登录',
        //     type: 'error',
        //     duration: 5 * 1000
        //   })
        }
        // return Promise.reject( '请求失败')
      }
      return res
  },
  error => {
    console.error('响应错误：', error)
    // ElMessage({
    //   message: error.msg || '请求失败',
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)


export default service